

function commonReducer(currentState, newState) {
  return { ...currentState, ...newState }
}

export default commonReducer;
